import { apiRoutes } from 'config/apiRoutes'
import axios from 'libs/fetch'
import { useMutation, useQueryClient } from 'libs/query'
import { useTranslation } from 'libs/i18n'
import { useToast } from 'shared/hooks'
import { queryKeys } from 'config/queryKeys'

type UseMarkAsAbandonedProps = {
	id: number | undefined
	closeModal: () => void
}

export const useMarkAsAbandoned = ({ id, closeModal }: UseMarkAsAbandonedProps) => {
	const queryClient = useQueryClient()
	const { t } = useTranslation()

	const { mutate: markAsAbandonedMutation } = useMutation({
		mutationFn: (id: number) => axios.post(apiRoutes.bookingMarkAsAbandoned(id.toString())),
		onSuccess: () => {
			useToast({
				type: 'success',
				message: t('Booking marked as donated')
			})()

			if (id) {
				queryClient.invalidateQueries({ queryKey: queryKeys.bookings.detail(id.toString()) })
			}
			closeModal()
		},
		onError: (err: any) => {
			useToast({
				type: 'error',
				message: err.response?.data?.detail ?? t('Something went wrong')
			})()
		}
	})

	return {
		markAsAbandonedMutation
	}
}
